import WordScrambler from '../../utils/wordScrambler';

const scramblerContainer = document.querySelector('.words-scrambler__container .words-scrambler__text');
const scramblerWrapper = document.querySelector('.words-scrambler__wrapper');

const phrasesArray = Array.from(document.querySelectorAll('.words-scrambler__phrases__item')).map(
  (sentence) => sentence.innerHTML,
);

const scramblerInstance = new WordScrambler(scramblerContainer);

let counter = 0;
let animationStarted = false;

const initScrambler = (phrases, scramblerInst) => {
  scramblerInst.setText(phrases[counter]).then(() => {
    setTimeout(() => initScrambler(phrases, scramblerInst), 1500);
  });
  counter = (counter + 1) % phrases.length;
};

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !animationStarted) {
        animationStarted = true;
        scramblerInstance.setText('').then(() => {
          setTimeout(() => initScrambler(phrasesArray, scramblerInstance), 1500);
        });
      }
    });
  },
  { threshold: 0.1 },
);

if (scramblerWrapper) {
  observer.observe(scramblerWrapper);
}
